<template>
  <div ref="pdfContent" class="pdf-content">
    <CCard class="border-0">
      <CCardHeader v-if="!hideControls" class="no-print bg-transparent">
        <div class="float-right">
          <a href="#" class="btn btn-sm btn-info ml-1" @click="printContent">
            <CIcon name="cil-print" class="mr-1" /> Print
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="header">
          <CRow class="align-items-start mb-3">
            <CCol cols="3" md="2" class="text-left">
              <img
                :src="getImageUrl()"
                alt="Logo Syarikat"
                class="logo-image"
              />
            </CCol>
            <CCol cols="9" md="10" class="text-right company-info">
              <h1 class="company-name">{{ company.name }}</h1>
              <p class="company-tagline">{{ company.tagLine }}</p>
              <p class="company-regno">{{ "(" + company.regNo + ")" }}</p>
              <p class="company-address" v-html="formatAddress(company.address)"></p>
              <p class="company-phone">Tel: {{ company.phone }}</p>
            </CCol>
          </CRow>
          <hr class="thick-hr" />
        </div>
        <div class="document-details">
          <CRow>
            <CCol md="6">
              <p><strong>Date:</strong> {{ getRegistrationDate() }}</p>
              <p>Dear Sir/Mdm,</p>
              <p>
                <strong>Acknowledgement submission document:</strong>
                {{ getPlateNo() }}
              </p>
              <p><strong>Bank:</strong> {{ getLoanBankName() }}</p>
              <p v-html="formatAddress(getLoanBankAddress())"></p>
            </CCol>
            <CCol md="6" class="text-right">
              <p><strong>No:</strong> {{ stock.stockNo }}</p>
              <p><strong>Salesman:</strong> {{ getSalesmanName() }}</p>
            </CCol>
          </CRow>
        </div>
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>No</th>
              <th>Description</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.remarks }}</td>
            </tr>
          </tbody>
        </table>
        <div class="footer">
          <p>Thank you</p>
          <!-- <p>P/S: {{ report.remarksFooter }}</p> -->
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "WidgetsReportDocumentSubmission",
  props: {
    stock: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
      validator: (value) => {
        return ["name", "tagLine", "address", "phone", "logoUrl"].every(
          (prop) => prop in value
        );
      },
    },
    bank: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    hideControls: {
      type: Boolean,
      default: false,
    },

    // report: {
    //   type: Object,
    //   required: true,
    //   validator: (value) => {
    //     return [
    //       "date",
    //       "documentNumber",
    //       "bank",
    //       "reportNumber",
    //       "items",
    //       "remarksFooter",
    //     ].every((prop) => prop in value);
    //   },
    // },
  },
  data: () => {
    return {
      items: [
        { description: "INVOICE", remarks: "✔" },
        { description: "HANDLING FEE LETTER", remarks: "✔" },
        { description: "INDEMNITY LETTER", remarks: "✔" },
        { description: "ORIGINAL @ COPY REGN. CARD", remarks: "✔" },
        { description: "INSURANCE", remarks: "✔" },
        { description: "COPY ROAD TAX", remarks: "✔" },
        { description: "TRANSFER NAME ORIGINAL RECEIPT", remarks: "✔" },
        { description: "COPY AP", remarks: "✔" },
        { description: "COPY B2", remarks: "✔" },
        { description: "B7 (ORIGINAL)", remarks: "✔" },
        { description: "IC HIRER", remarks: "✔" },
        { description: "DELIVERY ORDER", remarks: "✔" },
      ],
    };
  },
  mounted() {
    this.forceA4Size();
  },
  methods: {
    forceA4Size() {
      const pdfContent = this.$refs.pdfContent;
      if (pdfContent) {
        pdfContent.style.width = "210mm";
      }
    },
    printContent() {
      const printContents = this.$refs.pdfContent.innerHTML;
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      window.location.reload();
    },
    getRegistrationDate() {
      try {
        const raw = this.stock && this.stock.registration && this.stock.registration.vehicleRegistrationDate;
        if (!raw) return "-";
        const d = new Date(raw);
        if (isNaN(d.getTime())) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return "-";
      }
    },
    getPlateNo() {
      try {
        return this.stock.registration.vehicleRegistrationNumber;
      } catch (error) {
        return "N/A";
      }
    },
    getLoanBankAddress() {
      try {
        console.log("getLoanBankAddress",this.bank);
        return this.bank.address;
      } catch (error) {
        return "N/A";
      }
    },
    getLoanBankName() {
      try {
        return this.bank.name;
      } catch (error) {
        return "N/A";
      }
    },
    getSalesmanName() {
      try {
        return this.stock.sale.salesMan?.fullName || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getImageUrl() {
      var url = this.removeTrailingSlash(apiUrl) + this.company.logoUrl;
      return url;
    },
    formatAddress(address) {
      if (!address) return "";
      return address.replace(/\n/g, "<br />");
    },
    saveAsPDF() {
      const element = this.$refs.pdfContent;
      const options = {
        margin: [0.5, 0.5, 0.5, 0.5], // Top, right, bottom, left
        filename: "DocumentSubmissionReport.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(options).save();
    },
    printContent() {
      const printContents = this.$refs.pdfContent.innerHTML;
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.thick-hr {
  border: 1px solid #000;
  margin: 10px 0;
}

.pdf-content {
  width: 210mm;
  max-width: 100%;
  margin: 0 auto;
  padding: 15mm;
  box-sizing: border-box;
  background-color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.2;
  color: #333;
}

.logo-image {
  max-width: 120px;
  height: auto;
  display: block;
}

.header {
  page-break-after: avoid;
  page-break-inside: avoid;
  margin-bottom: 15px;
}

.company-info {
  padding-left: 15px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
  line-height: 1.2;
}

.company-tagline,
.company-regno,
.company-address,
.company-phone {
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 1.3;
}

.document-details {
  page-break-inside: avoid;
  margin-bottom: 20px;
}

.table {
  width: 100%;
  page-break-inside: auto;
  border-collapse: collapse;
}

/* Compact table styling to fit content on one page */
.table-sm th,
.table-sm td {
  padding: 5px 8px !important;
  line-height: 1.3;
  vertical-align: middle;
}

.table thead {
  page-break-after: avoid;
}

.table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.footer {
  page-break-inside: avoid;
  margin-top: 20px;
}

.footer p {
  margin: 0;
}

@media print {
  .no-print {
    display: none !important;
  }

  .pdf-content {
    width: 794px;
    margin: 0;
    padding: 20px;
    box-shadow: none;
  }

  .pdf-content .card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .pdf-content .card-body {
    padding: 0 !important;
  }

  .logo-image {
    max-width: 100px !important;
  }

  .company-name {
    font-size: 18px !important;
  }

  body {
    background: white;
  }

  .table {
    font-size: 11px;
  }

  .table th,
  .table td {
    padding: 8px;
  }

  /* Ensure compact styling in print/PDF mode */
  .table-sm th,
  .table-sm td {
    padding: 4px 6px !important;
    line-height: 1.2 !important;
    font-size: 10px !important;
  }
}

/* PDF Generation specific styles */
.pdf-content.pdf-generation {
  width: 794px !important;
  padding: 0 !important;
  margin: 0;
}

.pdf-content.pdf-generation .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pdf-content.pdf-generation .card-body {
  padding: 0 !important;
}

.pdf-content.pdf-generation .no-print {
  display: none !important;
}

.pdf-content.pdf-generation .logo-image {
  max-width: 100px !important;
}

.pdf-content.pdf-generation .company-name {
  font-size: 18px !important;
}

.pdf-content.pdf-generation .table {
  width: 100%;
  font-size: 11px;
}
</style>
